/**
 * @generated SignedSource<<8d13dfb3bdacd075942fc02e71e50b84>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespSortItems_itemSearch$data = {
  readonly sort: {
    readonly options: ReadonlyArray<{
      readonly urlLabel: string | null;
      readonly linkReference: string | null;
      readonly displayName: string | null;
    } | null> | null;
    readonly currentOption: {
      readonly urlLabel: string | null;
    } | null;
  } | null;
  readonly " $fragmentType": "SbRespSortItems_itemSearch";
};
export type SbRespSortItems_itemSearch$key = {
  readonly " $data"?: SbRespSortItems_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespSortItems_itemSearch">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlLabel",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespSortItems_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SortType",
      "kind": "LinkedField",
      "name": "sort",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SearchBrowseSortAvailableOptions",
          "kind": "LinkedField",
          "name": "options",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "linkReference",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SearchBrowseSortCurrentOption",
          "kind": "LinkedField",
          "name": "currentOption",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
})();

(node as any).hash = "67d09e7a3205650df601a6107e2c7b22";

export default node;
